<style>

.tableDesign .el-input__inner {
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs
        active-name="1"
        tab-position="left"
        style="background-color: #ffffff;height: 800px"
        @tab-click="handleTabClick"
      >
        <el-row :gutter="10" style="margin: 1rem 0">
          <CommonExcel
            ref="CommonExcelRef2"
            :import-p="'config:userLabel:import'"
            :export-p="'config:userLabel:export'"
            :import-method="importCfg"
            :export-method="exportCfg"
          />
          <clear-cache-apply v-if="type==1" />
        </el-row>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%" height="600">
              <el-table-column label="序号" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template v-slot:default="{row}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template v-slot:default="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                  <el-button type="success" size="mini" @click="handleCopy(row)">拷贝</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button
                v-prevent-re-click
                type="primary"
                size="mini"
                style="margin:10px 10px"
                @click="handleSaveConfig()"
              >保存
              </el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog :show-close="false" :before-close="handleClose" title="提示" :visible.sync="dialog" width="70%">
        <el-table
          :key="tableKey"
          size="mini"
          :data="diaLogList"
          border
          fit
          highlight-current-row
          style="width: 100%;"
          height="500"
        >
          <template v-if="type === 1">
            <el-table-column label="关卡" align="center" width="50">
              <template v-slot:default="{row,$index}">
                <span style="display:block;" :title="row.stage">{{ $index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="物件模板" align="center">
              <template v-slot:default="{row}">
                <el-select v-model="row.shapeId" @change="handleChangeShapeId(row)">
                  <el-option v-for="item in list[3]" :key="item.id" :value="item.id" :label="item.name" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="奖励" align="center">
              <template v-slot:default="scope">
                <Reward v-model="scope.row.reward" />
              </template>
            </el-table-column>
            <el-table-column label="地图行" align="center">
              <template v-slot:default="{row}">
                <el-input-number
                  v-model.number="row.row"
                  :controls="false"
                  :min="1"
                  :max="7"
                  placeholder="行"
                  @change="handleChangeXY(row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="地图列" align="center">
              <template v-slot:default="{row}">
                <el-input-number
                  v-model.number="row.col"
                  :controls="false"
                  :min="1"
                  :max="7"
                  placeholder="列"
                  @change="handleChangeXY(row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="编辑障碍物" align="center">
              <template v-slot:default="scope">
                <el-button type="text" @click="handleEdit(2,scope.row)"><i class="el-icon-edit-outline" /></el-button>
              </template>
            </el-table-column>
            <el-table-column label="物件" align="center">
              <template v-slot:default="scope">
                <div
                  style="width: 100%;height: 100%;min-height: 1rem;white-space: pre-wrap"
                  @click="handleEditShapeNum(scope.row.shapeId,scope.row.shape, scope.$index)"
                >
                  <i class="el-icon-edit-outline" style="margin-right: 0.5rem" />
                  <pre>{{ handleShapeNumShow(scope.row.shapeId, scope.row.shape) }}</pre>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="编辑地图物件" align="center">
              <template v-slot:default="scope">
                <el-button type="text" @click="handleEdit(1,scope.row)"><i class="el-icon-edit-outline" /></el-button>
              </template>
            </el-table-column>
            <el-table-column label="展示台行" align="center">
              <template v-slot:default="{row}">
                <el-input-number
                  v-model.number="row.basketRow"
                  :controls="false"
                  :min="1"
                  :max="99"
                  placeholder="行"
                  @change="handleChangeBasketXY(row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="展示台列" align="center">
              <template v-slot:default="{row}">
                <el-input-number
                  v-model.number="row.basketCol"
                  :controls="false"
                  :min="1"
                  :max="99"
                  placeholder="列"
                  @change="handleChangeBasketXY(row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="编辑展示台" align="center">
              <template v-slot:default="scope">
                <el-button type="text" @click="handleEdit(3,scope.row)"><i class="el-icon-edit-outline" /></el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button
                  style="margin-left: .5rem;display:block;"
                  size="mini"
                  type="danger"
                  @click="deleteRewardDialogList($index)"
                >删除
                </el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type === 2">
            <el-table-column label="序号" align="center" width="50">
              <template v-slot:default="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column prop="maxNum" label="购买次数">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.maxNum" placeholder="Id" />
              </template>
            </el-table-column>
            <el-table-column prop="expireTime" label="过期时间(秒)">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.expireTime" :disabled="scope.$index < 3" placeholder="过期时间(秒)" />
              </template>
            </el-table-column>
            <el-table-column label="价格" align="center">
              <Price :limit-type="[2]" :can-free="false" />
            </el-table-column>
            <el-table-column label="是否随机礼包" align="center" width="120">
              <template v-slot:default="scope">
                <el-checkbox v-model="scope.row.isRandom" @change="(val) => handleRandomChange(scope.row, val)" />
              </template>
            </el-table-column>
            <el-table-column prop="prize" label="奖励" align="center">
              <template v-slot:default="{row}">
                <Reward v-if="!row.isRandom" v-model="row.prize" />
                <el-button v-else type="text" @click.stop="openRandomGoodsDialog(row)">配置随机奖励</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button
                  style="margin-left: .5rem;display:block;"
                  size="mini"
                  type="danger"
                  @click="deleteRewardDialogList($index)"
                >删除
                </el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type === 3">
            <el-table-column prop="id" label="id">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.id" placeholder="Id" />
              </template>
            </el-table-column>
            <el-table-column prop="expireTime" label="名称">
              <template v-slot:default="scope">
                <el-input v-model="scope.row.name" placeholder="名称" />
              </template>
            </el-table-column>
            <el-table-column prop="expireTime" label="过期时间(秒)">
              <template v-slot:default="scope">
                <el-select v-model="scope.row.shapeId">
                  <el-option v-for="item in shapeSelect" :key="item.id" :value="item.id" :label="item.name" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button
                  style="margin-left: .5rem;display:block;"
                  size="mini"
                  type="danger"
                  @click="deleteRewardDialogList($index)"
                >删除
                </el-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button
          size="small"
          type="primary"
          :disabled="addMaxNum()"
          @click="addRewardDialogList"
        >新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button
          v-prevent-re-click
          type="primary"
          size="mini"
          style="margin:10px 10px"
          @click="handleSaveConfig()"
        >保存
        </el-button></span>
        <span slot="footer" class="dialog-footer"><el-button size="small" @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
      <el-dialog title="提示" :visible.sync="makeDiaLog" width="60%">
        <div class="container">
          <div v-if="makeType === 1 || makeType === 3">
            <div class="objects-container">
              <div
                v-for="(obj,i) in objects"
                :key="'obj-'+i"
                class="draggable-object"
                :style="getObjectStyle(obj)"
                draggable="true"
                @dragstart="onDragStart($event, obj)"
              >
                <span style="font-size: 10px;">{{ obj.name }}</span>
              </div>
            </div>
            <div class="plate-container">
              <div
                ref="plate"
                :style="{
                  position: 'relative',
                  display: 'inline-block',
                  border: '2px solid #333',
                  backgroundColor: '#f9f9f9',
                  width: `calc(${cellSize}px * ${gridCol})`,
                  height: `calc(${cellSize}px * ${gridRow})`,
                }"
                class="plate"
                @dragover.prevent
                @drop="onDrop"
              >
                <div v-for="(row, rowIndex) in grid" :key="'row-'+rowIndex" class="row">
                  <div
                    v-for="(cell, colIndex) in row"
                    :key="'cell-'+rowIndex+'-'+colIndex"
                    class="cell"
                    :class="{'highlight': isHighlighted(rowIndex, colIndex),[`occupied-${cell.objIndex}`]: cell.objIndex}"
                    @mouseover="highlightArea(rowIndex, colIndex)"
                  >
                    {{ cell.objId || '' }}
                  </div>
                </div>
                <div
                  v-for="item in placedObjects"
                  :key="'placed-'+item.index"
                  class="placed-object"
                  :style="getPlacedStyle(item)"
                  draggable="true"
                  @dragstart="onPlacedDragStart($event, item)"
                  @click.stop="rotateObject(item)"
                >
                  <span v-if="item.id >0" style="font-size: 10px">{{
                    item.name + ',角度:' + onRotatedName(item.rotated)
                  }}</span>
                  <span v-else style="font-size: 12px;color: red">禁</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="makeType === 2">
            <div class="objects-container">
              <div
                v-for="obj in rock"
                :key="'obj-'+obj.id"
                class="draggable-object"
                :style="getObjectStyle(obj)"
                draggable="true"
                @dragstart="onDragStart2($event, obj)"
              >
                <!--          {{ obj.id+"_"+obj.name }}-->
              </div>
            </div>
            <div class="plate-container">
              <div
                ref="plate"
                :style="{
                  position: 'relative',
                  display: 'inline-block',
                  border: '2px solid #333',
                  backgroundColor: '#f9f9f9',
                  width: `calc(${cellSize}px * ${gridCol})`,
                  height: `calc(${cellSize}px * ${gridRow})`,
                }"
                class="plate"
                @dragover.prevent
                @drop="onDrop2"
              >
                <div v-for="(row, rowIndex) in rockGrid" :key="'row-'+rowIndex" class="row">
                  <div
                    v-for="(cell, colIndex) in row"
                    :key="'cell-'+rowIndex+'-'+colIndex"
                    class="cell"
                    :class="{'highlight': isHighlighted(rowIndex, colIndex),[`occupied-${cell.objIndex}`]: cell.objIndex}"
                    @mouseover="highlightArea(rowIndex, colIndex)"
                  >
                    <!--              {{ cell.objId || '' }}-->
                  </div>
                </div>
                <div
                  v-for="item in rockObjects"
                  :key="'rock-'+item.index"
                  class="placed-object"
                  :style="getPlacedStyle(item)"
                  draggable="true"
                  @dragstart="onPlacedDragStart2($event, item)"
                >
                  <!--            {{ '序号:'+item.index + ',物件:' + item.name  }}-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button
          size="small"
          type="primary"
          @click="printGrid"
        >保存</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button size="small" @click="resetGrid">重置</el-button></span>
      </el-dialog>
      <el-drawer
        append-to-body
        :show-close="false"
        :before-close="handleRandomGoodsClose"
        title="配置随机奖励"
        :visible.sync="randomGoodsDialog"
        size="40%"
      >
        <template #title>
          <span>配置随机奖励</span>
        </template>
        <el-form :inline="true">
          <el-row v-for="(r,i) in currentRandomGoods" :key="i">
            <el-form-item label="序号" style="margin-top: 10px;margin-bottom: 12px!important;">
              <el-input-number v-model="r.id" :controls="false" :min="1" size="small" style="width: 80px;" disabled />
            </el-form-item>
            <el-form-item label="商品" style="margin-top: 10px;margin-bottom: 12px!important;">
              <el-cascader
                v-model.number="r.propsId"
                size="small"
                :options="propsOption"
                :props="{ expandTrigger: 'hover',emitPath:false }"
                :show-all-levels="false"
                style="width: 150px;"
              />
            </el-form-item>
            <el-form-item label="数量" style="margin-top: 10px;margin-bottom: 12px!important;">
              <el-input v-model.number="r.num" size="small" style="width: 90px;" placeholder="数量" />
            </el-form-item>
            <el-form-item label="权重" style="margin-top: 10px;margin-bottom: 12px!important;">
              <el-input v-model.number="r.weight" size="small" style="width: 90px;" placeholder="权重" />
            </el-form-item>
          </el-row>
        </el-form>
        <div style="margin-top: 20px; text-align: right; padding-right: 20px;">
          <el-button
            v-prevent-re-click
            type="primary"
            size="mini"
            style="margin:10px 10px"
            @click="handleSaveConfig()"
          >保存</el-button>
          <el-button size="small" @click="randomGoodsDialog = false">关 闭</el-button>
        </div>
      </el-drawer>
      <el-dialog title="物件配置" :visible.sync="shapeDialog" width="40%" @close="shapeDialogCLose">
        <el-table
          size="mini"
          :data="shapeDialogList"
          border
          fit
          highlight-current-row
          style="width: 100%;"
          height="500"
        >
          <el-table-column label="物件" align="center">
            <template v-slot:default="{row}">
              <el-select v-model="row.id">
                <el-option v-for="item in shapeDialogSelect" :key="item.id" :value="item.id" :label="item.name" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center" width="150">
            <template v-slot:default="{row}">
              <el-input v-model="row.num" placeholder="速度" />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template v-slot:default="{row,$index}">
              <el-button
                style="margin-left: .5rem;display:block"
                type="danger"
                size="mini"
                @click="deleteShapeDialogList($index)"
              >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button
          type="primary"
          @click="addShapeDialogList"
        >新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button @click="shapeDialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { actAuxiliary, actionActAuxiliary, delActAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import Price from '@/components/Price/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { getRewardType } from '@/api/config/slot'
import { getCacheConfig } from '@/utils'

export default {
  name: 'AuxDiggingTreasure',
  components: { ClearCacheApply, Price, CommonExcel, Reward },
  data() {
    return {
      tableKey: 0,
      loading: false,
      dialog: false,
      diaLogList: [],
      currentEditRowIndex: undefined,
      makeDiaLog: false,
      makeDiaData: [],
      makeDiaStatus: 1,
      list: [],
      type: 1,
      typeArr: { 1: '关卡配置', 2: '商品配置', 3: '物件配置' },
      curClass: 'digging_treasure',
      shapeSelect: [
        { id: 1, name: '物件1(1x1)', width: 1, height: 1 },
        { id: 2, name: '物件2(1x2)', width: 1, height: 2 },
        { id: 3, name: '物件3(1x3)', width: 1, height: 3 },
        { id: 4, name: '物件4(1x4)', width: 1, height: 4 },
        { id: 5, name: '物件5(2x2)', width: 2, height: 2 },
        { id: 6, name: '物件6(2x3)', width: 2, height: 3 },
        { id: 7, name: '物件7(2x3)', width: 2, height: 3 },
        { id: 8, name: '物件8(2x4)', width: 2, height: 4 },
        { id: 9, name: '物件9(3x3)', width: 3, height: 3 },
        { id: 10, name: '物件10(3x3)', width: 3, height: 3 }
      ],
      shapeDialog: false,
      shapeDialogSelect: [],
      shapeDialogList: [],
      shapeDialogIndex: 0,

      //* ***************************************************************************************************************/
      makeType: 1,
      cellSize: 40, // 每个格子的大小
      grid: [], // 9x9网格数据
      dragData: null, // 当前拖拽的数据
      placedObjects: [], // 已放置的物件
      dragPreview: null, // 拖拽预览位置
      highlightRect: null, // 高亮区域
      gridOutput: null, // 网格输出
      gridCol: 7,
      gridRow: 6,
      // 可拖拽物件定义
      actionObjects: [],
      defaultObjects: [
        { id: 1, name: '物件1(1x1)', width: 1, height: 1, index: 0, color: '#88ec8c', rotated: 0 },
        { id: 2, name: '物件2(1x2)', width: 1, height: 2, index: 0, color: '#4ca6ee', rotated: 0 },
        { id: 3, name: '物件3(1x3)', width: 1, height: 3, index: 0, color: '#ea674a', rotated: 0 },
        { id: 4, name: '物件4(1x4)', width: 1, height: 4, index: 0, color: '#d03be8', rotated: 0 },
        { id: 5, name: '物件5(2x2)', width: 2, height: 2, index: 0, color: '#12b2a5', rotated: 0 },
        { id: 6, name: '物件6(2x3)', width: 2, height: 3, index: 0, color: '#eccf5a', rotated: 0 },
        { id: 7, name: '物件7(2x3)', width: 2, height: 3, index: 0, color: '#f50c0c', rotated: 0 },
        { id: 8, name: '物件8(2x4)', width: 2, height: 4, index: 0, color: '#1d1fb7', rotated: 0 },
        { id: 9, name: '物件9(3x3)', width: 3, height: 3, index: 0, color: '#27f137', rotated: 0 },
        { id: 10, name: '物件10(3x3)', width: 3, height: 3, index: 0, color: '#e2c3e8', rotated: 0 }
      ],
      objects: [
        { id: 1, name: '物件1(1x1)', width: 1, height: 1, index: 0, color: '#88ec8c', rotated: 0 },
        { id: 2, name: '物件2(1x2)', width: 1, height: 2, index: 0, color: '#4ca6ee', rotated: 0 },
        { id: 3, name: '物件3(1x3)', width: 1, height: 3, index: 0, color: '#ea674a', rotated: 0 },
        { id: 4, name: '物件4(1x4)', width: 1, height: 4, index: 0, color: '#d03be8', rotated: 0 },
        { id: 5, name: '物件5(2x2)', width: 2, height: 2, index: 0, color: '#12b2a5', rotated: 0 },
        { id: 6, name: '物件6(2x3)', width: 2, height: 3, index: 0, color: '#eccf5a', rotated: 0 },
        { id: 7, name: '物件7(2x3)', width: 2, height: 3, index: 0, color: '#f50c0c', rotated: 0 },
        { id: 8, name: '物件8(2x4)', width: 2, height: 4, index: 0, color: '#1d1fb7', rotated: 0 },
        { id: 9, name: '物件9(3x3)', width: 3, height: 3, index: 0, color: '#27f137', rotated: 0 },
        { id: 10, name: '物件10(3x3)', width: 3, height: 3, index: 0, color: '#e2c3e8', rotated: 0 }
      ],
      rock: [
        { id: 3, name: '2次', width: 1, height: 1, index: 0, color: '#446177' },
        { id: 4, name: '禁止', width: 1, height: 1, index: 0, color: '#7f21f3' }
      ],
      rockGrid: [],
      rockObjects: [],
      randomGoodsDialog: false,
      currentRandomGoods: [],
      currentEditRow: null,
      propsOption: [
        {
          value: 100000,
          label: '等级金币',
          children: [],
          props: [14, 5001, 5002, 5003, 5004, 5005, 5006, 5007, 5008, 5009, 5010, 5011, 5012, 5013, 5014, 5015, 5016, 5017, 5018, 5019, 5020]
        },
        {
          value: 100001,
          label: '常规道具',
          children: [],
          props: [15, 16, 22, 37, 42, 65, 74, 82, 83, 89, 90, 109, 110, 111]
        },
        { value: 100002, label: '卡片道具', children: [], props: [1, 2, 3, 13, 79, 18, 107, 108] },
        {
          value: 100003,
          label: '皮肤道具',
          children: [],
          props: [19, 23, 71, 86, 62, 67, 68, 76, 77, 78, 101, 102, 103, 104, 105, 106]
        },
        {
          value: 100004,
          label: '活动道具',
          children: [],
          props: [25, 28, 31, 32, 36, 41, 53, 55, 72, 73, 75, 80, 81, 85, 88]
        },
        {
          value: 100005,
          label: '方块道具',
          children: [],
          props: [1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1011]
        }
      ]
    }
  },
  created() {
    this.init()
    this.initPropsOption()
  },
  methods: {
    init() {
      this.getList()
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {
        })
    },
    openDialog(config) {
      this.currentEditRowIndex = this.list[this.type].findIndex(item => item.config === config)
      this.tableKey++
      this.diaLogList = config.map(item => ({
        ...item,
        isRandom: item.isRandom || false,
        randomGoods: item.randomGoods || [],
        prize: item.prize || []
      }))
      this.dialog = true
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleDel(index, id) {
      this.$confirm('确认要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (id !== 0) {
          delActAuxiliary({ idList: [id] })
        }
        this.list[this.type].splice(index, 1)
      })
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    handleCopy(row) {
      const _row = Object.assign({}, row)
      _row.id = 0
      this.list[this.type].push(_row)
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name === sheet) {
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    handleSaveConfig() {
      for (let i = 0; i < this.list[1].length; i++) {
        for (let j = 0; j < this.list[1][i].config.length; j++) {
          if (this.list[1][i].config[j].basket.length === 0) {
            this.$message({ showClose: true, message: '第' + (j + 1) + '行，收集物盘子配置为空', type: 'error' })
            return
          }
          if (this.list[1][i].config[j].specifyShape.length > 0) {
            if (this.list[1][i].config[j].basket.length !== this.list[1][i].config[j].specifyShape.length) {
              this.$message({ showClose: true, message: '第' + (j + 1) + '行，收集物盘子与编辑物件盘子数量不一致', type: 'error' })
              return
            }
            let totalBox = 0
            for (let k = 0; k < this.list[1][i].config[j].shape.length; k++) {
              const tmp = this.handleGetShapeName(this.list[1][i].config[j].shape[k])
              totalBox += tmp.width * tmp.height
            }
            if (totalBox > (this.list[1][i].config[j].row * this.list[1][i].config[j].col)) {
              this.$message({ showClose: true, message: '第' + (j + 1) + '行，物件占用大于格子数量', type: 'error' })
              return
            }
          } else {
            if (this.list[1][i].config[j].basket.length !== this.list[1][i].config[j].shape.length) {
              this.$message({ showClose: true, message: '第' + (j + 1) + '行，收集物盘子与物件数量不一致', type: 'error' })
              return
            }
          }
        }
      }

      if (this.dialog && this.currentEditRowIndex !== undefined && this.currentEditRowIndex !== -1) {
        this.$set(this.list[this.type][this.currentEditRowIndex], 'config', JSON.parse(JSON.stringify(this.diaLogList)))
      }

      const saveList = JSON.parse(JSON.stringify(this.list))
      for (const type in saveList) {
        if (type === 2) {
          saveList[type].forEach(config => {
            if (config.config && Array.isArray(config.config)) {
              config.config = config.config.map(item => {
                const saved = { ...item }
                if (!saved.isRandom) {
                  delete saved.randomGoods
                } else {
                  delete saved.prize
                }
                return saved
              })
            }
          })
        }
      }

      actionActAuxiliary({ class: this.curClass, list: saveList }).then(response => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      fileName = this.typeArr[type]
      switch (type) {
        case 1:
          for (let i = 0; i < dataArr.length; i++) {
            const tAk = this.$refs.CommonExcelRef2.makeExcelData(dataArr[i], { id: 'id', num: '折扣', color: '颜色' })
            hearer.push(tAk[0])
            excelData.push(tAk[1])
          }
          break
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addRewardDialogList() {
      switch (this.type) {
        case 1:
          this.diaLogList.push({
            stage: this.diaLogList.length + 1,
            row: 1,
            col: 1,
            basketRow: 1,
            basketCol: 1,
            basket: [],
            shape: [],
            reward: [],
            deck: [[1]],
            specifyShape: []
          })
          break
        case 3:
          this.diaLogList.push({ id: this.diaLogList.length + 1, name: '', shapeId: 1 })
          break
        case 2:
          this.diaLogList.push({
            mtype: 2,
            bet: 1,
            sku: '',
            price: 0,
            coin: 'money1',
            prize: [],
            maxNum: 1,
            expireTime: 0,
            isRandom: false,
            randomGoods: []
          })
          this.diaLogList.push({
            mtype: 2,
            bet: 1,
            sku: '',
            price: 0,
            coin: 'money1',
            prize: [],
            maxNum: 1,
            expireTime: 0,
            isRandom: false,
            randomGoods: []
          })
          this.diaLogList.push({
            mtype: 2,
            bet: 1,
            sku: '',
            price: 0,
            coin: 'money1',
            prize: [],
            maxNum: 1,
            expireTime: 0,
            isRandom: false,
            randomGoods: []
          })
          this.diaLogList.push({
            mtype: 2,
            bet: 1,
            sku: '',
            price: 0,
            coin: 'money1',
            prize: [],
            maxNum: 1,
            expireTime: 3600,
            isRandom: false,
            randomGoods: []
          })
          this.diaLogList.push({
            mtype: 2,
            bet: 1,
            sku: '',
            price: 0,
            coin: 'money1',
            prize: [],
            maxNum: 1,
            expireTime: 0,
            isRandom: true,
            randomGoods: []
          })
          break
      }
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    },
    handleGrid(row, col) {
      const arr = []
      for (let i = 0; i < row; i++) {
        arr[i] = []
        for (let j = 0; j < col; j++) {
          arr[i][j] = 1
        }
      }
      return arr
    },
    handleChangeShapeId(row) {
      for (let i = 0; i < this.diaLogList.length; i++) {
        this.diaLogList[i].shapeId = row.shapeId
      }
      this.$forceUpdate()
    },
    handleChangeXY(row) {
      row.deck = this.handleGrid(row.row, row.col)
      row.specifyShape = []
    },
    handleChangeBasketXY(row) {
      row.basket = []
    },
    handleShapeNumShow(shapeId, data) {
      const numArr = {}
      for (let i = 0; i < data.length; i++) {
        if (!numArr[data[i]]) {
          numArr[data[i]] = 0
        }
        numArr[data[i]] = numArr[data[i]] + 1
      }
      let str = ''
      for (const k in numArr) {
        str += '物件：' + this.handleGetShapeName(shapeId, k).name + '，数量：' + numArr[k] + '\n'
      }
      return str
    },
    handleGetShapeName(shapeId, id) {
      const shapeSelect = this.handleGetShapeConfigById(shapeId)
      for (let i = 0; i < shapeSelect.length; i++) {
        if (shapeSelect[i].id === id) {
          return shapeSelect[i]
        }
      }
      return ''
    },
    handleGetShapeConfigById(shapeId) {
      for (let i = 0; i < this.list[3].length; i++) {
        if (this.list[3][i].id === shapeId) {
          return this.list[3][i].config
        }
      }
      return []
    },
    handleEditShapeNum(shapeId, config, index) {
      this.shapeDialogList = []
      const numArr = {}
      for (let i = 0; i < config.length; i++) {
        if (!numArr[config[i]]) {
          numArr[config[i]] = 0
        }
        numArr[config[i]] = numArr[config[i]] + 1
      }
      for (const id in numArr) {
        this.shapeDialogList.push({ id: parseInt(id), num: numArr[id] })
      }
      this.shapeDialogIndex = index
      this.shapeDialogSelect = []
      const shapeConfig = this.handleGetShapeConfigById(shapeId)
      for (let i = 0; i < shapeConfig.length; i++) {
        this.shapeDialogSelect.push({ id: shapeConfig[i].id, name: shapeConfig[i].name })
      }
      this.shapeDialog = true
    },
    shapeDialogCLose() {
      const data = []
      for (let i = 0; i < this.shapeDialogList.length; i++) {
        for (let j = 0; j < this.shapeDialogList[i].num; j++) {
          data.push(this.shapeDialogList[i].id)
        }
      }
      this.diaLogList[this.shapeDialogIndex].shape = data
    },
    deleteShapeDialogList(index) {
      this.shapeDialogList.splice(index)
    },
    addShapeDialogList() {
      this.shapeDialogList.push({ id: 1, num: 1 })
    },
    //* ***************************************************************************************************************//
    initializeGrid() {
      this.grid = Array(this.gridRow).fill().map(() =>
        Array(this.gridCol).fill().map(() => ({ objId: 0, objIndex: 0 }))
      )
      this.rockGrid = Array(this.gridRow).fill().map(() =>
        Array(this.gridCol).fill().map(() => ({ objId: 0, objIndex: 0 }))
      )
    },

    // 重置网格
    resetGrid() {
      this.initializeGrid()
      this.placedObjects = []
      this.rockObjects = []
      this.dragPreview = null
      this.highlightRect = null
      this.gridOutput = null
      this.makeDiaStatus = 1
      this.updateGrid()
    },

    // 获取物件样式
    getObjectStyle(obj) {
      return {
        width: `${obj.width * this.cellSize}px`,
        height: `${obj.height * this.cellSize}px`,
        lineHeight: `${obj.height * this.cellSize}px`,
        backgroundColor: obj.color
      }
    },

    // 获取已放置物件样式
    getPlacedStyle(item) {
      return {
        top: `${item.row * this.cellSize}px`,
        left: `${item.col * this.cellSize}px`,
        width: `${item.width * this.cellSize}px`,
        height: `${item.height * this.cellSize}px`,
        backgroundColor: item.color
      }
    },

    // 开始拖拽新物件
    onDragStart(event, obj) {
      this.dragData = {
        type: 'new',
        obj: { ...obj }
      }
      this.dragData.obj.index = this.placedObjects.length + 1

      // 设置拖拽图像
      event.dataTransfer.setDragImage(new Image(), 0, 0)
    },

    // 开始拖拽已放置的物件
    onPlacedDragStart(event, item) {
      if (item.id < 0) {
        return
      }
      event.stopPropagation()

      this.dragData = {
        type: 'placed',
        obj: { ...item },
        originalIndex: item.index,
        originalId: item.id
      }

      // 设置拖拽图像
      event.dataTransfer.setDragImage(new Image(), 0, 0)
    },

    // 拖拽放置
    onDrop(event) {
      if (!this.dragData) return

      const plate = this.$refs.plate
      const plateRect = plate.getBoundingClientRect()
      const x = event.clientX - plateRect.left
      const y = event.clientY - plateRect.top

      // 计算放置位置
      const col = Math.round(x / this.cellSize - this.dragData.obj.width / 2)
      const row = Math.round(y / this.cellSize - this.dragData.obj.height / 2)

      // 边界检查
      const boundedCol = Math.max(0, Math.min(col, this.gridCol - this.dragData.obj.width))
      const boundedRow = Math.max(0, Math.min(row, this.gridRow - this.dragData.obj.height))

      // 检查是否与其他物件重叠(排除自己)
      if (this.checkOverlap(boundedRow, boundedCol, this.dragData.obj, this.dragData.originalIndex)) {
        this.$message.error('放置位置与其他物件重叠！1')
        return
      }

      if (this.dragData.type === 'new') {
        // 放置新物件
        this.placedObjects.push({
          ...this.dragData.obj,
          row: boundedRow,
          col: boundedCol
        })
      } else {
        // 重新摆放已放置的物件
        const index = this.placedObjects.findIndex(item => item.index === this.dragData.originalIndex)
        if (index !== -1) {
          this.placedObjects[index].row = boundedRow
          this.placedObjects[index].col = boundedCol
        }
      }

      // 更新网格状态
      this.updateGrid()

      // 重置拖拽状态
      this.dragData = null
      this.dragPreview = null
    },

    // 检查是否与其他物件重叠
    checkOverlap(row, col, obj, excludeId = null) {
      for (let r = row; r < row + obj.height; r++) {
        for (let c = col; c < col + obj.width; c++) {
          if (r >= this.gridRow || c >= this.gridCol) {
            return true
          } // 超出边界
          if (this.grid[r][c].objIndex && this.grid[r][c].objIndex !== excludeId) {
            return true // 与其他物件重叠
          }
        }
      }
      return false
    },

    // 更新网格状态
    updateGrid() {
      // 先清空网格
      this.initializeGrid()
      if (this.makeType === 1 && this.makeDiaStatus === 1) {
        this.makeDiaStatus = 0
        let index = -1
        for (let i = 0; i < this.makeDiaData.deck.length; i++) {
          for (let j = 0; j < this.makeDiaData.deck[i].length; j++) {
            if (this.makeDiaData.deck[i][j] >= 4) {
              const tmp = { ...this.handleGetObjectsById(2, this.makeDiaData.deck[i][j]) }
              tmp.id = -4
              tmp.index = index
              tmp.row = i
              tmp.col = j
              index -= 1
              this.placedObjects.push(tmp)
            }
          }
        }
      }
      this.placedObjects.forEach(obj => {
        for (let r = obj.row; r < obj.row + obj.height; r++) {
          for (let c = obj.col; c < obj.col + obj.width; c++) {
            if (c < this.gridCol && r < this.gridRow) {
              this.grid[r][c].objId = obj.id
              this.grid[r][c].objIndex = obj.index
            }
          }
        }
      })
      this.rockObjects.forEach(obj => {
        for (let r = obj.row; r < obj.row + obj.height; r++) {
          for (let c = obj.col; c < obj.col + obj.width; c++) {
            if (c < this.gridCol && r < this.gridRow) {
              this.rockGrid[r][c].objId = obj.id
              this.rockGrid[r][c].objIndex = obj.index
            }
          }
        }
      })
    },

    // 高亮显示可能放置的区域
    highlightArea(row, col) {
      return false
    },

    // 判断单元格是否在高亮区域
    isHighlighted(row, col) {
      return false
    },
    rotateObject(item) {
      if (item.id < 0) {
        return
      }
      // 检查旋转后是否会超出边界或与其他物件重叠
      const newWidth = item.height
      const newHeight = item.width

      if (item.row + newHeight > this.gridCol || item.col + newWidth > this.gridRow) {
        this.$message.error('旋转后物件将超出边界！')
        return
      }
      // 临时检查重叠
      const tempItem = {
        ...item,
        width: newWidth,
        height: newHeight
      }

      if (this.checkOverlap(item.row, item.col, tempItem, item.index)) {
        this.$message.error('旋转后物件将与其他物件重叠！')
        return
      }

      if (!item.rotated) {
        item.rotated = 1
      } else {
        item.rotated += 1
        item.rotated = item.rotated % 4
      }

      // 执行旋转
      item.width = newWidth
      item.height = newHeight

      // 更新网格
      this.updateGrid()
    },
    onRotatedName(rotate) {
      if (!rotate) {
        return '0'
      } else if (rotate === 1) {
        return '90'
      } else if (rotate === 2) {
        return '180'
      } else if (rotate === 3) {
        return '270'
      } else {
        return '0'
      }
    },

    // 开始拖拽新物件
    onDragStart2(event, obj) {
      this.dragData2 = {
        type: 'new',
        obj: { ...obj }
      }
      this.dragData2.obj.index = this.rockObjects.length + 1

      // 设置拖拽图像
      event.dataTransfer.setDragImage(new Image(), 0, 0)
    }, // 拖拽放置
    onDrop2(event) {
      if (!this.dragData2) return

      const plate = this.$refs.plate
      const plateRect = plate.getBoundingClientRect()
      const x = event.clientX - plateRect.left
      const y = event.clientY - plateRect.top

      // 计算放置位置
      const col = Math.round(x / this.cellSize - this.dragData2.obj.width / 2)
      const row = Math.round(y / this.cellSize - this.dragData2.obj.height / 2)

      // 边界检查
      const boundedCol = Math.max(0, Math.min(col, this.gridCol - this.dragData2.obj.width))
      const boundedRow = Math.max(0, Math.min(row, this.gridRow - this.dragData2.obj.height))

      // 检查是否与其他物件重叠(排除自己)
      if (this.checkOverlap2(boundedRow, boundedCol, this.dragData2.obj, this.dragData2.originalIndex)) {
        this.$message.error('放置位置与其他物件重叠！2')
        return
      }

      if (this.dragData2.type === 'new') {
        // 放置新物件
        this.rockObjects.push({
          ...this.dragData2.obj,
          row: boundedRow,
          col: boundedCol
        })
      } else {
        // 重新摆放已放置的物件
        const index = this.rockObjects.findIndex(item => item.index === this.dragData2.originalIndex)
        if (index !== -1) {
          this.rockObjects[index].row = boundedRow
          this.rockObjects[index].col = boundedCol
        }
      }

      // 更新网格状态
      this.updateGrid()

      // 重置拖拽状态
      this.dragData2 = null
      this.dragPreview = null
    },
    onPlacedDragStart2(event, item) {
      event.stopPropagation()

      this.dragData2 = {
        type: 'placed',
        obj: { ...item },
        originalIndex: item.index,
        originalId: item.id
      }

      // 设置拖拽图像
      event.dataTransfer.setDragImage(new Image(), 0, 0)
    },
    checkOverlap2(row, col, obj, excludeId = null) {
      for (let r = row; r < row + obj.height; r++) {
        for (let c = col; c < col + obj.width; c++) {
          if (r >= this.gridRow || c >= this.gridCol) return true // 超出边界
          if (this.rockGrid[r][c].objIndex && this.rockGrid[r][c].objIndex !== excludeId) {
            return true // 与其他物件重叠
          }
        }
      }
      return false
    },
    handleGetShapeById(id) {
      for (let i = 0; i < this.shapeSelect.length; i++) {
        if (this.shapeSelect[i].id === id) {
          return this.shapeSelect[i]
        }
      }
      return null
    },
    handleGetObjectsById(makeType, id) {
      if (makeType === 2) {
        for (let i = 0; i < this.rock.length; i++) {
          if (this.rock[i].id === id) {
            return this.rock[i]
          }
        }
        return null
      } else {
        for (let i = 0; i < this.actionObjects.length; i++) {
          if (this.actionObjects[i].id === id) {
            return this.actionObjects[i]
          }
        }
        return null
      }
    },
    // 打印当前网格状态
    printGrid() {
      if (this.makeType === 2) {
        const arr = this.handleGrid(this.gridRow, this.gridCol)
        for (let i = 0; i < this.gridRow; i++) {
          for (let j = 0; j < this.gridCol; j++) {
            if (this.rockGrid[i][j].objId > 2) {
              arr[i][j] = this.rockGrid[i][j].objId
            }
          }
        }
        this.makeDiaData.deck = arr
      } else {
        const list = []
        for (let i = 0; i < this.placedObjects.length; i++) {
          if (this.placedObjects[i].id > 0) {
            list.push({
              id: this.placedObjects[i].id,
              rotated: this.placedObjects[i].rotated,
              col: this.placedObjects[i].col,
              row: this.placedObjects[i].row
            })
          }
        }
        if (this.makeType === 3) {
          this.makeDiaData.basket = list
        } else {
          this.makeDiaData.specifyShape = list
        }
      }
      this.makeDiaLog = false
    },
    handleMakeActionObjects(shapeId) {
      this.actionObjects = []
      const config = this.handleGetShapeConfigById(shapeId)
      for (let i = 0; i < config.length; i++) {
        let tmp = {}
        for (let j = 0; j < this.defaultObjects.length; j++) {
          if (this.defaultObjects[j].id === config[i].id) {
            tmp = this.defaultObjects[j]
          }
        }
        const shape = this.handleGetShapeById(config[i].shapeId)
        tmp.name = config[i].name
        tmp.width = shape.width
        tmp.height = shape.height
        this.actionObjects.push(tmp)
      }
      console.log(this.actionObjects)
    },
    handleEdit(makeType, data) {
      this.makeType = makeType
      this.makeDiaData = data
      this.makeDiaStatus = 1
      let index = 1
      if (this.makeType === 2) {
        this.rockObjects = []
        for (let i = 0; i < data.deck.length; i++) {
          for (let j = 0; j < data.deck[i].length; j++) {
            if (data.deck[i][j] > 2) {
              const tmp = { ...this.handleGetObjectsById(2, data.deck[i][j]) }
              tmp.index = index
              tmp.row = i
              tmp.col = j
              index += 1
              this.rockObjects.push(tmp)
            }
          }
        }
        this.gridCol = data.col
        this.gridRow = data.row
      } else if (this.makeType === 1) {
        this.handleMakeActionObjects(data.shapeId)
        this.placedObjects = []
        let index = 1
        for (let i = 0; i < data.specifyShape.length; i++) {
          const tmp = { ...this.handleGetObjectsById(1, data.specifyShape[i].id) }
          tmp.index = index
          tmp.row = data.specifyShape[i].row
          tmp.col = data.specifyShape[i].col
          tmp.rotated = data.specifyShape[i].rotated
          index += 1
          this.placedObjects.push(tmp)
        }
        for (let i = 0; i < this.placedObjects.length; i++) {
          if (this.placedObjects[i].rotated === 1 || this.placedObjects[i].rotated === 3) {
            const tmp = this.placedObjects[i].width
            this.placedObjects[i].width = this.placedObjects[i].height
            this.placedObjects[i].height = tmp
          }
        }
        this.gridCol = data.col
        this.gridRow = data.row
        this.objects = JSON.parse(JSON.stringify(this.actionObjects))
      } else if (this.makeType === 3) {
        this.handleMakeActionObjects(data.shapeId)
        this.objects = []
        if (data.specifyShape.length > 0) {
          for (let i = 0; i < data.specifyShape.length; i++) {
            this.objects.push({ ...this.handleGetObjectsById(3, data.specifyShape[i].id) })
          }
        } else {
          for (let i = 0; i < data.shape.length; i++) {
            this.objects.push({ ...this.handleGetObjectsById(3, data.shape[i]) })
          }
        }
        this.placedObjects = []
        let index = 1
        for (let i = 0; i < data.basket.length; i++) {
          const tmp = { ...this.handleGetObjectsById(3, data.basket[i].id) }
          tmp.index = index
          tmp.row = data.basket[i].row
          tmp.col = data.basket[i].col
          tmp.rotated = data.basket[i].rotated
          index += 1
          this.placedObjects.push(tmp)
        }
        for (let i = 0; i < this.placedObjects.length; i++) {
          if (this.placedObjects[i].rotated === 1 || this.placedObjects[i].rotated === 3) {
            const tmp = this.placedObjects[i].width
            this.placedObjects[i].width = this.placedObjects[i].height
            this.placedObjects[i].height = tmp
          }
        }
        this.gridCol = data.basketCol
        this.gridRow = data.basketRow
      }
      this.updateGrid()
      this.makeDiaLog = true
    },
    initPropsOption() {
      getCacheConfig(getRewardType, 'getRewardType1', { data: 1 }).then(res => {
        const rewardTypeMap = res.data
        for (const i in rewardTypeMap) {
          const propsId = parseInt(i)
          for (let j = 0; j < this.propsOption.length; j++) {
            if (this.propsOption[j].props.indexOf(propsId) >= 0) {
              this.propsOption[j].children.push({ label: rewardTypeMap[i], value: propsId })
              break
            }
          }
        }
      })
    },
    handleRandomGoodsClose(done) {
      done()
    },
    handleRandomChange(row, val) {
      if (val) {
        if (!row.randomGoods || row.randomGoods.length === 0) {
          row.randomGoods = []
          for (let i = 1; i <= 8; i++) {
            row.randomGoods.push({ id: i, propsId: 74, num: 1, weight: 100 })
          }
        }
        row.prize = []
      } else {
        row.randomGoods = []
        row.prize = []
      }
    },
    openRandomGoodsDialog(row) {
      this.currentEditRow = row
      this.currentRandomGoods = row.randomGoods || []
      this.randomGoodsDialog = true
    },
    addMaxNum() {
      switch (this.type) {
        case 2:
          if (this.diaLogList.length >= 3) {
            return true
          }
          break
      }
      return false
    }
  }
}
</script>

<style scoped>
.container {
  /*max-width: 800px;*/
  padding: 20px;
  text-align: center;
  margin: 0 auto;
}

.controls {
  margin: 20px 0;
}

.objects-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 20px 0;
}

.draggable-object {
  color: white;
  text-align: center;
  cursor: move;
  border-radius: 4px;
  user-select: none;
  padding: 0 10px;
  box-sizing: border-box;
}

.plate-container {
  display: inline-block;
  margin-top: 20px;
}

.plate {
  position: relative;
  display: inline-block;
  border: 2px solid #333;
  background-color: #f9f9f9;
  width: calc(40px * 9);
  height: calc(40px * 9);
}

.row {
  display: flex;
}

.cell {
  width: 40px;
  height: 40px;
  border: 1px solid #ddd;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.cell.highlight {
  background-color: #fff9c4;
}

/* 不同物件的占用样式 */
.cell.occupied-1 {
  background-color: rgba(76, 175, 80, 0.3);
}

.cell.occupied-2 {
  background-color: rgba(33, 150, 243, 0.3);
}

.cell.occupied-3 {
  background-color: rgba(156, 39, 176, 0.3);
}

.placed-object {
  position: absolute;
  cursor: move;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  z-index: 10;
}

.drag-preview {
  position: absolute;
  background-color: rgba(255, 193, 7, 0.3);
  border: 2px dashed #FFA000;
  z-index: 5;
  pointer-events: none;
}

.grid-output {
  margin-top: 20px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
  text-align: left;
}

.grid-output pre {
  margin: 0;
  font-family: monospace;
}
</style>
